import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  
  const routeLabels = {
    '/dashboard': 'Dashboard',
    '/ai-content-creator': 'AI Content Creator',
    '/press-kit-builder': 'Press Kit Builder',
    '/media-contacts': 'Media Contacts',
    '/email-campaign-manager': 'Email Campaign Manager',
    '/analytics-dashboard': 'Analytics Dashboard',
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
  
  if (pathSegments?.length === 0 || location?.pathname === '/dashboard') {
    return null;
  }

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/dashboard' }
  ];

  let currentPath = '';
  pathSegments?.forEach((segment) => {
    currentPath += `/${segment}`;
    const label = routeLabels?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1);
    breadcrumbItems?.push({ label, path: currentPath });
  });

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          {index === breadcrumbItems?.length - 1 ? (
            <span className="text-foreground font-medium">{item?.label}</span>
          ) : (
            <Link
              to={item?.path}
              className="hover:text-foreground transition-colors duration-200"
            >
              {item?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;